module.exports = __webpack_public_path__ + "static/media/email-icn.a646086b.svg";